<div *ngIf="isLoadingResults" class="wrapperLoader">
  <div class="loader">
  </div>
</div>
<nav aria-label="breadcrumb" class="bg-none sticky-top">
  <ol class="breadcrumb bg-white border-bottom pl-4 mb-0">
    <div class="col-xs-12 col-md-6 d-flex flex-wrap">
      <span class="w-100">Package Management</span>
      <li class="breadcrumb-item"><a href="/dashboard">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Package Management</li>
    </div>
    <div class="col-xs-12 col-md-6">
      <div class="d-flex mr-3" style="justify-content: flex-end;">
        <a [routerLink]="['/packages/create']" class="btn package-btn mt-md-2 mt-0">
          <img src="assets/images/add.png" class="pb-1 pr-1">
          Add Package</a>
      </div>
    </div>
  </ol>
</nav>

<div class="container-fluid">
  <div class="kg-data-table table-responsive">
    <div class="kg-form-data kg-data-2 position-relative mb-md-4 mb-2 mt-md-3 mt-2">
      <span class="position-absolute kg-tag">Assign overpack</span>
      <div class="form-row mt-2">
        <div class="form-group col-md-3">
          <label class="label-txt" for="status">Select country</label>
          <select floatinputModel class="form-control input" id="status" [(ngModel)]="countryId" 
            (change)="onCountryChange(countryId)">
            <!-- <option value="">Select</option> -->
            <option *ngFor="let country of ddlCountries" [value]="country.countryId">{{country.countryName}}</option>
            <!-- <option> </option> -->
          </select>
          <span class="bar"></span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="assign-overpack">
            <div class="ao-num-box">
              <div class="ao-num-item">
                <h3>{{totalItems}} </h3>
                <p>Packages to be shipped</p>
              </div>
              <div class="ao-num-item">
                <span></span>
              </div>
              <div class="ao-num-item">
                <h3>{{inBinLocation}} out of {{totalItems}}</h3>
                <p>Packages are in Bin Location</p>
              </div>
            </div>
            <div class="ao-table">
              <table class="table mb-0 table-striped text-center">
                <thead>
                  <tr>
                    <th>Package ID</th>
                    <th>Bin Location ID</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody *ngIf="list.length > 0" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
                  (scrolled)="onScrollDown()" [infiniteScrollDisabled]="isScroll" [scrollWindow]="false">
                  <tr *ngFor="let row of list; index as i">
                    <td>
                      <a href="javascript:void(0)"
                        [routerLink]="getRedirectURL(row.statusInt, row.packageId, row.hasPickTicket, row.binLocationReferenceNumber)">
                        {{row.packageCode}}
                      </a>
                    </td>
                    <td>{{row.binLocationReferenceNumber}}</td>
                    <td>{{row.status}}</td>
                  </tr>
                  <tr><td colspan="4">
                    <span class="fa fa-spinner fa-spin" *ngIf="packageLoading"></span>
                  </td></tr>
                </tbody>
                <tbody *ngIf="list.length === 0 && packageLoading"><tr><td colspan="4">
                  <span class="fa fa-spinner fa-spin" *ngIf="packageLoading"></span>
                </td></tr></tbody>
                <tbody *ngIf="list.length === 0 && !packageLoading">
                  <tr>
                    <td colspan="4">
                      <div class="col-md-12 text-center text-info">
                        <h6>
                          <span class="tim-note">No Records.</span>
                        </h6>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="assign-overpack">
            <div class="ao-inp-box">
              <div class="form-row">
                <div class="form-group col-md-5">
                  <div class="d-flex txt-loding">
                  <label class="label-txt" for="tnumber">Scan Package </label>
                  <input class="form-control input" floatinputModel type="text" #packageFocus
                    type="text" [(ngModel)]="search" (input)="focusOutScanPackage()">
                  <!-- <input class="form-control input" floatinputModel type="text" aria-label="Search"
                    type="text" [(ngModel)]="search" typeaheadOptionField="result" [typeahead]="suggestions$"
                    [typeaheadAsync]="true" (typeaheadLoading)="changeTypeaheadLoading($event)"
                    (typeaheadOnSelect)="typeaheadPackageOnSelect($event)" [typeaheadMinLength]="2"
                    [typeaheadHideResultsOnBlur]="false"> -->
                    <span class="bar"></span>
                  
                    <i class="fa fa-spinner fa-spin" *ngIf="isSearchLoading"></i>                 
                  </div>
                </div>
                <div class="form-group col-md-4">
                  <div class="d-flex txt-loding">
                  <label class="label-txt" for="tnumber">Scan Overpack </label>
                  <input class="form-control input" floatinputModel type="text" aria-label="Search" #overpackFocus
                    type="text" [(ngModel)]="searchOverpack" (input)="focusOutScanOverpack()">
                  <!-- <input class="form-control input" floatinputModel type="text" aria-label="Search"
                    type="text" [(ngModel)]="searchOverpack" typeaheadOptionField="result" [typeahead]="suggestions1$"
                    [typeaheadAsync]="true" (typeaheadLoading)="changeTypeaheadLoading1($event)"
                    (typeaheadOnSelect)="typeaheadOverpackOnSelect($event)" [typeaheadMinLength]="2"
                    [typeaheadHideResultsOnBlur]="false"> -->
                    <span class="bar"></span>            
                    <i class="fa fa-spinner fa-spin" *ngIf="isSearchLoadingOverpack"></i> 
                  </div>
                </div>
                <!-- <div class="form-group col-md-3">
                  <div class="kg-cust-btn">
                    <div class="d-flex" style="justify-content: flex-end;margin-top: -6px;">
                      <button class="btn btn-info" type="button" (click)="onAssignOverpack()">Assign</button>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
            <div class="ao-table">
              <table class="table mb-0 table-striped text-center">
                <thead>
                  <tr>
                    <th>Package ID</th>
                    <th>Overpack ID</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody *ngIf="overpackedList.length === 0 && overpackedPackageLoading"><tr><td colspan="4">
                  <span class="fa fa-spinner fa-spin" *ngIf="overpackedPackageLoading"></span>
                </td></tr></tbody>
                <tbody *ngIf="overpackedList.length > 0" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
                  (scrolled)="onOverpackedScrollDown()" [infiniteScrollDisabled]="isScroll" [scrollWindow]="false">
                  <tr *ngFor="let row of overpackedList; index as i">
                    <td> 
                      <a href="javascript:void(0)"
                        [routerLink]="getRedirectURL(row.statusInt, row.packageId, row.hasPickTicket, row.binLocationReferenceNumber)">
                        {{row.packageCode}}
                      </a>
                    </td>
                    <td>{{row.overpackCode}}</td>
                    <td>{{row.status}}</td>
                  </tr>
                  <tr><td colspan="4">
                    <span class="fa fa-spinner fa-spin" *ngIf="overpackedPackageLoading"></span>
                  </td></tr>
                </tbody>
                <tbody *ngIf="overpackedList.length === 0 && !overpackedPackageLoading">
                  <tr>
                    <td colspan="4">
                      <div class="col-md-12 text-center text-info">
                        <h6>
                          <span class="tim-note">No Records.</span>
                        </h6>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>